'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxLabelWrapper = exports.CheckboxWrapper = exports.CheckboxBox = exports.CheckboxLabel = exports.CheckboxInput = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  cursor: inherit;\n  pointer-events: all;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  left: 0px;\n  box-sizing: border-box;\n  padding: 0px;\n  margin: 0px;\n'], ['\n  position: absolute;\n  cursor: inherit;\n  pointer-events: all;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  left: 0px;\n  box-sizing: border-box;\n  padding: 0px;\n  margin: 0px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  display: block;\n  font-family: inherit;\n  line-height: ', ';\n  position: relative;\n  transition: color .3s;\n  white-space: ', ';\n'], ['\n  color: ', ';\n  display: block;\n  font-family: inherit;\n  line-height: ', ';\n  position: relative;\n  transition: color .3s;\n  white-space: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border-radius: 2px;\n  border: 2px solid ', ';\n  display: block;\n  flex-shrink: 0;\n  height: ', 'px;\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n  position: relative;\n  width: ', 'px;\n  transition-property: background-color, border-color;\n  transition-duration: .3s;\n\n  ', '\n\n  ', '\n\n  &::before {\n    box-sizing: border-box;\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    content: \'\';\n    display: block;\n    width: ', 'px;\n    height: ', 'px;\n    border: ', 'px solid;\n    border-color: ', ';\n    border-top-width: 0;\n    border-right-width: 0;\n    transition-duration: .3s;\n    transition-timing-function: .3s;\n    transition-property: transform, opacity;\n    transform-origin: top left;\n    transform: rotateZ(-45deg) scale(.5) translate(-50%, -50%);\n    opacity: 0;\n\n    ', '\n  }\n'], ['\n  background-color: ', ';\n  border-radius: 2px;\n  border: 2px solid ', ';\n  display: block;\n  flex-shrink: 0;\n  height: ', 'px;\n  margin-left: ', 'px;\n  margin-right: ', 'px;\n  position: relative;\n  width: ', 'px;\n  transition-property: background-color, border-color;\n  transition-duration: .3s;\n\n  ', '\n\n  ', '\n\n  &::before {\n    box-sizing: border-box;\n    position: absolute;\n    top: 40%;\n    left: 50%;\n    content: \'\';\n    display: block;\n    width: ', 'px;\n    height: ', 'px;\n    border: ', 'px solid;\n    border-color: ', ';\n    border-top-width: 0;\n    border-right-width: 0;\n    transition-duration: .3s;\n    transition-timing-function: .3s;\n    transition-property: transform, opacity;\n    transform-origin: top left;\n    transform: rotateZ(-45deg) scale(.5) translate(-50%, -50%);\n    opacity: 0;\n\n    ', '\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  height: auto;\n  max-width: ', ';\n  min-height: 24px;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n'], ['\n  height: auto;\n  max-width: ', ';\n  min-height: 24px;\n  overflow: visible;\n  position: relative;\n  width: 100%;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  align-items: center;\n  cursor: ', ';\n  display: inline-flex;\n  position: relative;\n  justify-content: space-between;\n\n  ', '\n'], ['\n  align-items: center;\n  cursor: ', ';\n  display: inline-flex;\n  position: relative;\n  justify-content: space-between;\n\n  ', '\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getLabelColor = function getLabelColor(props) {
  if (props.disabled) {
    return props.theme.color.base3;
  }

  if (props.checked) {
    if (props.labelVariant) {
      return props.theme.color[props.labelVariant];
    }

    return props.theme.color[props.variant];
  }
  return props.variant === 'white' ? props.theme.color.white : props.theme.color.base1;
};

var CheckboxInput = exports.CheckboxInput = _styledComponents2.default.input(_templateObject);

CheckboxInput.displayName = 'CheckboxInput';
var CheckboxLabel = exports.CheckboxLabel = _styledComponents2.default.label(_templateObject2, function (props) {
  return getLabelColor(props);
}, function (props) {
  return props.size;
}, function (props) {
  return props.wrapText ? 'normal' : 'nowrap';
});

CheckboxLabel.displayName = 'CheckboxLabel';
var CheckboxBox = exports.CheckboxBox = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.checked ? props.theme.color[props.variant] : props.theme.color.white;
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.size - 6;
}, function (props) {
  return props.labelPosition === 'right' ? 0 : 16;
}, function (props) {
  return props.labelPosition === 'right' ? 16 : 0;
}, function (props) {
  return props.size - 6;
}, function (props) {
  return props.disabled && '\n    background-color: ' + (props.checked && props.theme.color.base3) + ';\n    border-color: ' + props.theme.color.base3 + ';\n  ';
}, function (props) {
  if (props.checkboxPosition === 'top') {
    return '\n        margin-top: 4px;\n        margin-bottom: auto;\n      ';
  }

  if (props.checkboxPosition === 'bottom') {
    return '\n        margin-top: auto;\n        margin-bottom: 4px;\n      ';
  }

  return '\n      margin-top: auto;\n      margin-bottom: auto;\n    ';
}, function (props) {
  return Math.ceil(0.45 * props.size);
}, function (props) {
  return Math.ceil(0.2 * props.size);
}, function (props) {
  return props.size > 24 ? 3 : 2;
}, function (props) {
  return props.theme.color[props.tickVariant];
}, function (props) {
  return props.checked && '\n      transform: rotateZ(-45deg) translate(-50%, -50%);\n      opacity: 1;\n      transition-delay: .1s;\n    ';
});

CheckboxBox.displayName = 'CheckboxBox';
var CheckboxWrapper = exports.CheckboxWrapper = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.maxWidth;
});

CheckboxWrapper.displayName = 'CheckboxWrapper';
var CheckboxLabelWrapper = exports.CheckboxLabelWrapper = _styledComponents2.default.div(_templateObject5, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.fullWidth && '\n    width: 100%;\n  ';
});
CheckboxLabelWrapper.displayName = 'CheckboxLabelWrapper';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-checkbox/styles.js
// module id = 2895
// module chunks = 4